import { createContext, useContext } from 'react';
import type { BaselineNetwork, RcmBaselineLifecycleState } from '../../rcm-baseline/types';

export interface BaselineCtx {
  state: RcmBaselineLifecycleState;
  network: BaselineNetwork;
  /** Launch day has passed (Day-1 Review buttons become live). */
  launched: boolean;
  /** Open the drill-down drawer for a metric id. */
  openMetric: (id: string) => void;
}

const Ctx = createContext<BaselineCtx | null>(null);

export const BaselineProvider = Ctx.Provider;

export function useBaseline(): BaselineCtx {
  const ctx = useContext(Ctx);
  if (!ctx) throw new Error('useBaseline must be used inside a BaselineProvider');
  return ctx;
}
